module.exports = __webpack_public_path__ + "img/quick.f4248adc.svg";